'use strict';

/**
 * Grid Featured Video JS
 *
 * Loads video srcs on medium+ windows,
 * and enables looped videos to play on hover.
 */
(function() {

	/**
	 * Globals.
	 */
	const Breakpoints = Ring && Ring.Breakpoints; // ring.js
	let listening = false;

	/**
	 * Get video wrappers + load videos.
	 */
	function initialize() {
		const $wrappers = $('.vid-script__wrapper-tag');

		// check video wrappers
		if (!$wrappers.length) {
			return;
		}

		// initlal video loading
		handleResize($wrappers);

		// listen for resize
		window.addEventListener('resize', function() {
			handleResize($wrappers);
		});
	}

	/**
	 * Wait for DOM ready before init.
	 * Needed due to async loading.
	 */
	function initializeOnReady() {
		if (document.readyState == 'loading') {
			document.addEventListener('DOMContentLoaded', initialize);
		} else {

			// get this party started
			initialize();
		}
	}

	/**
	 * Load videos + add mouse listeners.
	 */
	function handleResize($wrappers) {
		loadVideos($wrappers);
		toggleListeneres($wrappers);
	}

	/**
	 * Load video from data-src if window is
	 * below medium breakpoint (768px).
	 */
	function loadVideos($wrappers) {
		if (window.innerWidth > Breakpoints.m) {
			const $videos = $wrappers.find('.vid-script__vid-tag');

			// check videos
			if ($videos.length) {

				// loop through videos and find source tags
				$videos.each(function() {
					const $vid = $(this);
					const $source = $vid.find('source');

					// load src if it is not present
					if (!$source.attr('src')) {
						const src = $source.data('src');
						$source.attr('src', src);
						$vid[0].load();
					}
				});

			}
		}
	}

	/**
	 * Add or remove mouseenter + mouseleave listeners.
	 * Set global listener boolean.
	 */
	function toggleListeneres($wrappers) {
		if ((window.innerWidth > Breakpoints.m) && listening == false) {
			$wrappers.mouseenter(handleMouseEnter);
			$wrappers.mouseleave(handleMouseLeave);
			listening = true;
		} else {
			$wrappers.off('mouseenter').off('mouseleave');
			listening = false;
		}
	}

	/**
	 * Fade image out and play video on mouseenter.
	 * 'invisible' class transitions opacity.
	 */
	function handleMouseEnter() {
		const $wrapper = $(this);
		const $img = $wrapper.find('.grid-featured-vid__img');
		const $vid = $wrapper.find('.vid-script__vid-tag');

		// check img and vid
		if ($img.length && $vid.length) {
			$img.addClass('invisible');
			$vid[0].play();
		}
	}


	/**
	 * Fade image in and pause video on mouseleave.
	 * 'invisible' class transitions opacity.
	 */
	function handleMouseLeave() {
		const $wrapper = $(this);
		const $img = $wrapper.find('.grid-featured-vid__img');
		const $vid = $wrapper.find('.vid-script__vid-tag');

		// check img and vid
		if ($img.length && $vid.length) {
			$img.removeClass('invisible');
			$vid[0].pause();
		}
	}

	/**
	 * Init when DOM is ready.
	 */
	initializeOnReady();
})();
